import { Code, PartnerPlan } from "@/domain/entities/PartnerPlan"
import { CodesResponseDataDTO } from "../dto/CodesResponseDTO"

const toDomain = (data: CodesResponseDataDTO): Code => {
    return {
        id: data.id,
        type: data.plan_type == 'full_access' ? "pro" : "basic",
        expiration_date: data.batch.expiration_date,
        identifier: data.code,
        used_by: data.redeemed_at && data.user ? {
            name: data.user.name,
            email: data.user.email,
            used_date: data.redeemed_at
        } : undefined
    }
}
const toPlanDomain = (data: CodesResponseDataDTO[]): PartnerPlan => {
    if (!data?.length) {
        return {
            id: "",
            partnership_id: "",
            codes: [],
            date_start: "",
            date_end: "",
            created_at: "",
            status: "inactive"
        }
    }
    return {
        id: "",
        partnership_id: data[0].partnership_id,
        codes: data.map(toDomain),
        date_start: "",
        date_end: "",
        created_at: "",
        status: "inactive"
    }
}
export default {
    toPlanDomain
}